var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome2Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5849 16.1122L16.2931 12.8204C16.8916 11.6234 17.2906 10.2269 17.2906 8.83037C17.2906 4.14209 13.5001 0.351562 8.81181 0.351562C4.12353 0.351562 0.333008 4.14209 0.333008 8.83037C0.333008 13.5186 4.12353 17.3092 8.81181 17.3092C10.2083 17.3092 11.6048 16.9102 12.8018 16.3117L16.0936 19.6034C17.0911 20.6009 18.5874 20.6009 19.5849 19.6034C20.4826 18.6059 20.4826 17.1097 19.5849 16.1122ZM8.81181 15.3142C5.22079 15.3142 2.32802 12.4214 2.32802 8.83037C2.32802 5.23934 5.22079 2.34658 8.81181 2.34658C12.4028 2.34658 15.2956 5.23934 15.2956 8.83037C15.2956 12.4214 12.4028 15.3142 8.81181 15.3142Z",
    fill: "#161E40"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.81494,
    cy: 8.83887,
    r: 6,
    stroke: "#F4B644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2Svg);
export default __webpack_public_path__ + "static/media/home2svg.358987b222b3015f32cd1fabed30ab89.svg";
export { ForwardRef as ReactComponent };